import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=83b16232"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports